export default {
  GET_SUBMISSIONS_SUMMARY_REQUEST: 'GET_SUBMISSIONS_SUMMARY_REQUEST',
  GET_SUBMISSIONS_SUMMARY_SUCCESS: 'GET_SUBMISSIONS_SUMMARY_SUCCESS',
  GET_SUBMISSIONS_SUMMARY_FAIL: 'GET_SUBMISSIONS_SUMMARY_FAIL',

  GET_STATISTICS_BY_DAY_REQUEST: 'GET_STATISTICS_BY_DAY_REQUEST',
  GET_STATISTICS_BY_DAY_SUCCESS: 'GET_STATISTICS_BY_DAY_SUCCESS',
  GET_STATISTICS_BY_DAY_FAIL: 'GET_STATISTICS_BY_DAY_FAIL',

  GET_STATISTICS_BY_WEEK_REQUEST: 'GET_STATISTICS_BY_WEEK_REQUEST',
  GET_STATISTICS_BY_WEEK_SUCCESS: 'GET_STATISTICS_BY_WEEK_SUCCESS',
  GET_STATISTICS_BY_WEEK_FAIL: 'GET_STATISTICS_BY_WEEK_FAIL',

  GET_STATISTICS_BY_MONTH_REQUEST: 'GET_STATISTICS_BY_MONTH_REQUEST',
  GET_STATISTICS_BY_MONTH_SUCCESS: 'GET_STATISTICS_BY_MONTH_SUCCESS',
  GET_STATISTICS_BY_MONTH_FAIL: 'GET_STATISTICS_BY_MONTH_FAIL',

  GET_STATISTICS_WORK_SUMMARY_REQUEST: 'GET_STATISTICS_WORK_SUMMARY_REQUEST',
  GET_STATISTICS_WORK_SUMMARY_SUCCESS: 'GET_STATISTICS_WORK_SUMMARY_SUCCESS',
  GET_STATISTICS_WORK_SUMMARY_FAIL: 'GET_STATISTICS_WORK_SUMMARY_FAIL',

  GET_STATISTICS_BY_DATE_REQUEST: 'GET_STATISTICS_BY_DATE_REQUEST',
  GET_STATISTICS_BY_DATE_SUCCESS: 'GET_STATISTICS_BY_DATE_SUCCESS',
  GET_STATISTICS_BY_DATE_FAIL: 'GET_STATISTICS_BY_DATE_FAIL',
  
  GET_USER_TASK_HISTORY_DASHBOARD_REQUEST: 'GET_USER_TASK_HISTORY_DASHBOARD_REQUEST',
  GET_USER_TASK_HISTORY_DASHBOARD_SUCCESS: 'GET_USER_TASK_HISTORY_DASHBOARD_SUCCESS',
  GET_USER_TASK_HISTORY_DASHBOARD_FAIL: 'GET_USER_TASK_HISTORY_DASHBOARD_FAIL',

  GET_COLLAB_TASK_ACCURACY_DASHBOARD_REQUEST: 'GET_COLLAB_TASK_ACCURACY_DASHBOARD_REQUEST',
  GET_COLLAB_TASK_ACCURACY_DASHBOARD_SUCCESS: 'GET_COLLAB_TASK_ACCURACY_DASHBOARD_SUCCESS',
  GET_COLLAB_TASK_ACCURACY_DASHBOARD_FAIL: 'GET_COLLAB_TASK_ACCURACY_DASHBOARD_FAIL',

  GET_VERIFIER_TASK_ACCURACY_DASHBOARD_REQUEST: 'GET_VERIFIER_TASK_ACCURACY_DASHBOARD_REQUEST',
  GET_VERIFIER_TASK_ACCURACY_DASHBOARD_SUCCESS: 'GET_VERIFIER_TASK_ACCURACY_DASHBOARD_SUCCESS',
  GET_VERIFIER_TASK_ACCURACY_DASHBOARD_FAIL: 'GET_VERIFIER_TASK_ACCURACY_DASHBOARD_FAIL',

  GET_DUE_WORK_SUMMARY_REQUEST: 'GET_DUE_WORK_SUMMARY_REQUEST',
  GET_DUE_WORK_SUMMARY_SUCCESS: 'GET_DUE_WORK_SUMMARY_SUCCESS',
  GET_DUE_WORK_SUMMARY_FAIL: 'GET_DUE_WORK_SUMMARY_FAIL',
}
